import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { API_URL } from '../constants/api';
import { lastValueFrom } from 'rxjs';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { CommonService } from 'src/app/shared/services/common.service';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  private permissions: string[] = [];

  constructor(
    private readonly http: HttpClient,
    private readonly commonService: CommonService
  ) {}

  setPermission(permissions: Array<any>) {
    this.permissions = permissions.map((data: any /**NOSONAR */) => data.key);
  }

  getPermission() {
    return this.permissions;
  }

  checkPermission(value: string): boolean {
    if (!value) {
      return true;
    } else {
      if (this.getPermission()?.includes(value)) {
        return true;
      } else {
        return false;
      }
    }
  }

  fetchScreenPermission() {
    return lastValueFrom(
      this.http.get(
        `${environment.COMPOSITE_BASE_URL}${API_URL.SCREEN_PERMISSION}`
      )
    );
  }

  async getScreenPermission() {
    const permissions = this.permissions;
    if (permissions.length <= 0) {
      const response: any = await this.fetchScreenPermission().catch(
        (error: HttpErrorResponse) => {
          this.commonService.showError(error);
        }
      );
      if (response && !response.error) {
        this.setPermission(response.data);
      }
    }
    return this.permissions;
  }
}
